// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"Home_loadingContainer__2TzaV","noToPayAmount":"Home_noToPayAmount__1u-Az"};